import React from 'react';

//STYLES
import {
  Box,
  Radio,
  FormControlLabel,
  Grid,
  Modal,
  FormControl,
  CircularProgress,
  RadioGroup,
  Typography,
  Button,
} from '@mui/material';
import { ModalBoxClube } from '../../BasicRegistration/styles';
import { ContentModalNewCard, TitleCards } from '../CardManagementStyles';

// ASSETS
import { Save } from '@mui/icons-material';

// COMPONENTS
import CardList from './CardList';
import CardUrl from './CardUrl';

export default function ViewModal({
  openModal,
  close,
  modalRef,
  isActiveOverflow,
  setIsActiveOverflow,
  generateNewCard,
  infosForEdit,
  formCard,
  setFormCard,
  handleChangeTypeCard,
  isNewCard,
  tags,
  setTags,
  url,
  errorUrl,
  setUrl,
  handleMaskUrl,
  typeLink,
  setTypeLink,
  cardDefault,
  setCardDefault,
  setScrollPosition,
  cardDefaultDetails,
  setCardDefaultDetails,
  chooseDate,
  handleDates,
  handleDateDefined,
  isPrivateCard,
  handlePrivacityCard,
  handlePublished,
  loading,
  selectedCardType,
  setSelectedCardType,
  cardTypes,
  handleAction,
  listType,
  setListType,
  setAppliedFilters,
  selectedEstablishment,
  setSelectedEstablishment,
  selectedStore,
  setSelectedStore,
  selectedProduct,
  setSelectedProduct,
  selectedIdEdit,
  selectedKeywords,
  setSelectedKeywords,
}) {
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={openModal}
      onClose={close}
    >
      <ModalBoxClube ref={modalRef} isActiveOverflow={isActiveOverflow}>
        <ContentModalNewCard onSubmit={generateNewCard}>
          <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Grid item md={12}>
              <TitleCards variant="h5" gutterBottom>
                {Object.keys(infosForEdit).length !== 0 && isNewCard === false
                  ? 'Editar card'
                  : 'Criar novo card'}
              </TitleCards>
            </Grid>
          </Grid>

          <FormControl component="fieldset">
            <Typography id="tipo-do-card" variant="subtitle1" fontWeight="bold" mb={1}>
              Selecione o tipo do card:
            </Typography>
            <RadioGroup
              row
              aria-labelledby="tipo-do-card"
              name="cardType"
              value={formCard.cardType}
              onChange={handleChangeTypeCard}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <FormControlLabel
                value="card_list"
                control={<Radio color="primary" />}
                label="Lista"
              />
              <FormControlLabel value="card_url" control={<Radio color="primary" />} label="Url" />
            </RadioGroup>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }}>
            {formCard.cardType === 'card_list' && (
              <CardList
                isNewCard={isNewCard}
                formCard={formCard}
                setFormCard={setFormCard}
                tags={tags}
                setTags={setTags}
                cardDefault={cardDefault}
                setCardDefault={setCardDefault}
                setScrollPosition={setScrollPosition}
                cardDefaultDetails={cardDefaultDetails}
                setCardDefaultDetails={setCardDefaultDetails}
                setIsActiveOverflow={setIsActiveOverflow}
                modalRef={modalRef}
                handlePublished={handlePublished}
                isPrivateCard={isPrivateCard}
                handlePrivacityCard={handlePrivacityCard}
                chooseDate={chooseDate}
                handleDateDefined={handleDateDefined}
                handleDates={handleDates}
                selectedCardType={selectedCardType}
                setSelectedCardType={setSelectedCardType}
                cardTypes={cardTypes}
                handleAction={handleAction}
                listType={listType}
                setListType={setListType}
                setAppliedFilters={setAppliedFilters}
                selectedEstablishment={selectedEstablishment}
                setSelectedEstablishment={setSelectedEstablishment}
                selectedStore={selectedStore}
                setSelectedStore={setSelectedStore}
                selectedProduct={selectedProduct}
                setSelectedProduct={setSelectedProduct}
                selectedIdEdit={selectedIdEdit}
                infosForEdit={infosForEdit}
                selectedKeywords={selectedKeywords}
                setSelectedKeywords={setSelectedKeywords}
              />
            )}

            {formCard.cardType === 'card_url' && (
              <CardUrl
                formCard={formCard}
                setFormCard={setFormCard}
                url={url}
                setUrl={setUrl}
                handleMaskUrl={handleMaskUrl}
                errorUrl={errorUrl}
                typeLink={typeLink}
                setTypeLink={setTypeLink}
                cardDefault={cardDefault}
                setCardDefault={setCardDefault}
                setScrollPosition={setScrollPosition}
                cardDefaultDetails={cardDefaultDetails}
                setCardDefaultDetails={setCardDefaultDetails}
                setIsActiveOverflow={setIsActiveOverflow}
                modalRef={modalRef}
                chooseDate={chooseDate}
                handleDates={handleDates}
                handleDateDefined={handleDateDefined}
                isPrivateCard={isPrivateCard}
                handlePrivacityCard={handlePrivacityCard}
                handlePublished={handlePublished}
              />
            )}
          </FormControl>

          {!isNewCard && formCard.cardType === 'card_list' && (
            <Box my={3} sx={{ width: '100%' }}>
              <Typography variant="body2" maxWidth="750px">
                <b>Atenção:</b> <br /> Este card pode conter regras de exibição avançadas
                configuradas pela área administrativa. Ao editar os filtros nesta página, todas as
                regras existentes serão substituídas pelas opções simplificadas disponíveis aqui.
                Recomendamos que alterações complexas sejam feitas na área administrativa para
                preservar as configurações atuais.
              </Typography>
            </Box>
          )}

          <Button
            variant="contained"
            type="submit"
            color="primary"
            startIcon={!loading ? <Save /> : null}
            disabled={loading}
          >
            {!loading ? (
              Object.keys(infosForEdit).length !== 0 && isNewCard === false ? (
                'Salvar card'
              ) : (
                'Criar card'
              )
            ) : (
              <CircularProgress size="1.5rem" sx={{ color: '#fff' }} />
            )}
          </Button>
        </ContentModalNewCard>
      </ModalBoxClube>
    </Modal>
  );
}
